/* Ignacio - ADA Drawer: Compatible with tab and focused when adding a product to cart */
document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector("#Cart-Drawer");

  // Handle product card "Add to Cart" buttons
  const addToCartButtons = document.querySelectorAll(
    ".product-card--add-to-cart-button"
  );
  
  // Handle product card "Add to Cart" buttons
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", async (e) => {
      cartDrawer.classList.add("active");
      cartDrawer.setAttribute("tabindex", "0");
      cartDrawer.focus();
      cartDrawer.setAttribute("aria-live", "polite");
      cartDrawer.setAttribute(
        "aria-label",
        "Shopping cart updated with new item"
      );
    });
  });

  // Handle single product page "Add to Cart" button
  const singleAddToCartButton = document.querySelector("#AddToCart");
  if (singleAddToCartButton) {
    singleAddToCartButton.addEventListener("click", async (e) => {
      cartDrawer.classList.add("active");
      cartDrawer.setAttribute("tabindex", "0");
      cartDrawer.focus();
      cartDrawer.setAttribute("aria-live", "polite");
      cartDrawer.setAttribute(
        "aria-label",
        "Shopping cart updated with new item"
      );
    });
  }

  // Close button logic
  const closeButton = document.querySelector(".side-panel-close");
  closeButton?.addEventListener("click", () => {
    cartDrawer.classList.remove("active");
    cartDrawer.setAttribute("tabindex", "-1");
  });
});


/* Ruyi - Discount plugin: Input element relies on the placeholder attribute as a fallback to provide an accessible name  */
try {
  const runScript = () => {
    const timeoutDuration = 5000; // 5 seconds
    const targetSelector = "input.lit__discount_input";
    const addTitle = (element) => {
      if (!element.hasAttribute('title')) {
        element.setAttribute('title', 'Enter your discount code or gift card');
      }
    };
    const initTitle = () => {
      const target = document.querySelector(targetSelector);
      if (target) {
        addTitle(target);
        new MutationObserver(() => addTitle(target)).observe(target, {
          attributes: true,
          attributeFilter: ['title'],
        });
        observer.disconnect();
        clearTimeout(timeoutId);
      }
    };
    const observer = new MutationObserver(() => initTitle());
    observer.observe(document.body, { childList: true, subtree: true });

    const timeoutId = setTimeout(() => {
      observer.disconnect();
    }, timeoutDuration);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runScript);
  } else {
    runScript();
  }
} catch (error) { }

/*  Fix free item only purchase */
const checkoutObserver = new MutationObserver((mutations, obs) => {
  const checkoutButtons = document.querySelectorAll('button.checkout-button');
  checkoutButtons.forEach((button) => {
    if (!button.dataset.listenerAdded) {
      button.dataset.listenerAdded = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var form = event.target.closest('form');
        if (!form && button.form) {
          form = button.form;
        } else if (!form) {
          return
        }
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const newForm = document.querySelector('form[action="/checkout"]');
            if (newForm && cart.total_price != 0) {
              newForm.submit();
            }
          })
          .catch(err => {});
      });
    }
  });
});

checkoutObserver.observe(document.body, {
  childList: true,
  subtree: true
});


// Listen for the Upcart close event and force-remove the open-cc class.
// That class causes the <div class='click-capture"/> element to be blurred. It normally is removed
// when clicked on, but the Upcart plugin adds its own overlay that can itercept the click, leaving the overlay blurry,
// This is a temp fix.
window.addEventListener('aftersell-upcart:public-events:cart-closed', () => document.body.classList.remove('open-cc'));

/* Jay - UpCart: temporarily pause checkout while cart updates are pending.
 * Works across click paths and network clients in this file.
 * Checkout is restored only after cart state is re-validated.
 */
(function () {
  const MUTATING_XHR_PATHS = ["/cart/change.js", "/cart/update.js", "/cart/add.js", "/cart/clear.js"];
  const BLOCKED_CHECKOUT_NAV_PATHS = ["/cart", "/checkout", "/checkouts"];

  let pendingMutations = 0;

  /** Get the Upcart checkout button through the shadow DOM */
  function getCheckoutButton() {
    return document.querySelector("#upCart")?.shadowRoot?.querySelector(".upcart-checkout-button");
  }

  /**
   * Checks if an XHR request path matches known cart mutation endpoints. This
   * is used to determine when to lock the checkout button.
   * @param {string} url Request URL.
   * @returns True if the URL is a cart mutation endpoint.
   */
  function isCartMutatingUrl(url) {
    try {
      const pathname = new URL(url, location.origin).pathname;
      return MUTATING_XHR_PATHS.some((p) => pathname === p || pathname.endsWith(p));
    } catch {
      return false;
    }
  }

  /**
   * Checks if a URL matches known blocked navigation paths. This is used to
   * determine when to block navigation to the checkout page while locked.
   *
   * @param {string} url URL of the navigation target.
   * @returns True if the URL is a blocked navigation path.
   */
  function isBlockedNavigationUrl(url) {
    try {
      const pathname = new URL(url, location.origin).pathname;
      return BLOCKED_CHECKOUT_NAV_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
    } catch {
      return false;
    }
  }

  /**
   * Checks if any element in the click event path is a checkout button or a
   * hyperlink to the checkout page, which should be blocked when mutations are
   * pending.
   * 
   * @param {HTMLElement[]} elPath All the elements in the path of the click
   * event, including those in shadow DOMs. All are checked to find a know
   * checkout button or hyperlink.
   * @returns 
   */
  function shouldBlockNavigation(elPath) {
    const isCheckoutButton = elPath.some((el) => el?.classList?.contains?.("upcart-checkout-button"));
    if (isCheckoutButton) return true;

    const hyperlink = elPath.find((el) => el?.tagName === "A" && typeof el.href === "string");
    if (hyperlink && isBlockedNavigationUrl(hyperlink.href)) return true;

    return false;
  }

  /**
   * The checkout button is a link but try hard to disabled it.
   * 
   * - pointer events are disabled to prevent clicks
   * - aria-disabled is set for screen readers
   * - href is changed to prevent navigation on click and original href is saved in a data attribute
   * - tabindex is set to -1 to remove it from the tab order and original tabindex is saved in a data attribute
   */
  function disableCheckoutButton() {
    const button = getCheckoutButton();
    if (!button) return;

    button.style.pointerEvents = "none";
    button.setAttribute("aria-disabled", "true");

    if (!button.hasAttribute("data-dtc-lock-href") && button.hasAttribute("href")) {
      button.setAttribute("data-dtc-lock-href", button.getAttribute("href") || "");
    }
    button.href = '#/loading';

    if (!button.hasAttribute("data-dtc-lock-tabindex")) {
      const currentTabIndex = button.getAttribute("tabindex");
      button.setAttribute("data-dtc-lock-tabindex", currentTabIndex === null ? "" : currentTabIndex);
    }
    button.setAttribute("tabindex", "-1");
  }

  /**
   * Reenables the checkout button by restoring all attributes changed in disableCheckoutButton.
   */
  function enableCheckoutButton() {
    const button = getCheckoutButton();
    if (!button) return;

    button.style.pointerEvents = "";
    button.removeAttribute("aria-disabled");

    if (button.hasAttribute("data-dtc-lock-href")) {
      const href = button.getAttribute("data-dtc-lock-href") || "";
      if (href) {
        button.setAttribute("href", href);
      }
      button.removeAttribute("data-dtc-lock-href");
    }

    if (button.hasAttribute("data-dtc-lock-tabindex")) {
      const previousTabIndex = button.getAttribute("data-dtc-lock-tabindex");
      if (previousTabIndex) {
        button.setAttribute("tabindex", previousTabIndex);
      } else {
        button.removeAttribute("tabindex");
      }
      button.removeAttribute("data-dtc-lock-tabindex");
    }
  }

  document.addEventListener(
    "click",
    /**
     * Checks all page clicks during the capture phase to see if they should be
     * blocked while cart mutations are pending.
     * @param {MouseEvent} e 
     */
    function captureCheckoutClick(e) {
      if (pendingMutations === 0) return;

      if (shouldBlockNavigation(e.composedPath())) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    { capture: true }
  );

  /**
   * Increments the count of pending mutations and disables the checkout button
   * to prevent checkout while cart updates are in-flight.
   */
  function lockCheckout() {
    pendingMutations++;
    disableCheckoutButton();
  }

  /**
   * Unlocks the checkout button if there are no more pending mutations,
   * allowing check out again. This must be called the same number of times as
   * lockCheckout to fully restore checkout functionality.
   */
  function unlockCheckout() {
    pendingMutations = Math.max(pendingMutations - 1, 0);
    if (pendingMutations > 0) return;

    // Re-check final cart state before unlocking checkout
    originalFetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        if (cart.total_price > 0) {
          enableCheckoutButton();
        }
        // If only no-cost items remain then keep checkout locked
      })
      .catch(() => {
        // stay locked on network error
      });
  }

  // Keep original fetch for the cart re-check request.
  const originalFetch = window.fetch.bind(window);

  // Override native fetch to intercept cart mutations and lock checkout while they are pending
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input instanceof Request ? input.url : "";

    if (isCartMutatingUrl(url)) {
      lockCheckout();
      return originalFetch(input, init).then(
        (r) => {
          unlockCheckout();
          return r;
        },
        (e) => {
          unlockCheckout();
          throw e;
        }
      );
    }

    return originalFetch(input, init);
  };

  // Same as for fetch, but with XHR
  const origXhrOpen = XMLHttpRequest.prototype.open;
  const origXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._dtcMutating = isCartMutatingUrl(url);
    return origXhrOpen.apply(this, [method, url, ...rest]);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this._dtcMutating) {
      lockCheckout();
      this.addEventListener("loadend", () => unlockCheckout());
    }
    return origXhrSend.apply(this, args);
  };
})();